"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(values, validateCallback) {
  var errors = [];
  values.forEach(function (item, index) {
    var itemErrors = validateCallback(item);
    if (!(0, _isEmpty2["default"])(itemErrors)) {
      errors[index] = itemErrors;
    }
  });
  return errors;
};